import React from "react";
import { Box, Skeleton } from "@mui/material";

interface CustomSkeletonProps {
  variant?: "text" | "rectangular" | "rounded" | "circular";
  width?: string | number;
  height?: string | number;
  animation?: "pulse" | "wave";
  count?: number;
  direction?: "row" | "column";
}

const CustomSkeleton: React.FC<CustomSkeletonProps> = ({
  variant = "rounded",
  width = "100%",
  height = 100,
  animation = "wave",
  count = 4,
  direction = "row",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: direction,
        gap: "0.8rem",
        padding: "0.5rem 1rem",
      }}
    >
      {Array.from(Array(count)).map((_, index) => (
        <Skeleton
          key={index}
          variant={variant}
          width={width}
          height={height}
          animation={animation}
        />
      ))}
    </Box>
  );
};

export default CustomSkeleton;
